import { iMachineProps } from "./Machine"

let k8sHosts = [
    'telemetry-ui-dev.op-epg1mi.gm.com',
    'telemetry-ui-qa.op-epg1mi.gm.com',
    'telemetry-ui-test.op-epg1mi.gm.com',
    'telemetry-ui-preprod.op12pdg1.gm.com',
    'telemetry-ui-prod.op12pdg1.gm.com'
];

let azureHosts = [
    '3dviz-tlm-ui-dev.musea2.azure.ext.gm.com',
    '3dviz-tlm-ui-qa-dev.musea2.azure.ext.gm.com',
    '3dviz-tlm-ui-test-dev.musea2.azure.ext.gm.com',
    '3dviz-tlm-ui.musea2.azure.ext.gm.com'
];

let pcfHosts = [
    'visualization-telemetry-dev.apps.pcfepg3mi.gm.com',
    'visualization-telemetry-qa.apps.pcfepg3mi.gm.com',
    'visualization-telemetry-test.apps.pcfepg3mi.gm.com',
    'visualization-telemetry-prod.apps.pcfepg3mi.gm.com'
];


const getApiPath = () => {
    // k8s telemetry backends
    if (k8sHosts.includes(window.location.host)) {

        if (window.location.host.includes('preprod')) {
            return new URL("https://invictus-telemetry-preprod.op12pdg1.gm.com/telemetry")

        } else if (window.location.host.includes('prod')) {
            return new URL("https://invictus-telemetry-prod.op12pdg1.gm.com/telemetry")

        } else if (window.location.host.includes('test')) {
            return new URL("https://invictus-telemetry-test.op-epg1mi.gm.com/telemetry")

        } else if (window.location.host.includes('qa')) {
            return new URL("https://invictus-telemetry-qa.op-epg1mi.gm.com/telemetry")

        } else {
            return new URL("https://invictus-telemetry-dev.op-epg1mi.gm.com/telemetry")
        }

    // Azure telemetry backends
    } else if (azureHosts.includes(window.location.host)) {

        if (window.location.host.includes('qa-dev')) {
            return new URL("https://3dviz-tlm-qa-dev.d7.a209890.musea2.azdt.gm.com/telemetry")

        } else if (window.location.host.includes('test-dev')) {
            return new URL("https://3dviz-tlm-test-dev.d8.a209890.musea2.azdt.gm.com/telemetry")

        } else if (window.location.host.includes('dev')) {
            return new URL("https://3dviz-tlm-dev.d6.a209890.musea2.azdt.gm.com/telemetry")

        } else {
            return new URL("https://3dviz-tlm.p1.a209890.musea2.azp.gm.com/telemetry")
        }

    // PCF telemetry backends
    } else if (pcfHosts.includes(window.location.host)) {

        if (window.location.host.includes('prod')) {
            return new URL("https://invictus-telemetry-prod.cpi.gm.com/telemetry")

        } else if (window.location.host.includes('test')) {
            return new URL("https://invictus-telemetry-test.apps.pcfepg3mi.gm.com/telemetry")

        } else if (window.location.host.includes('qa')) {
            return new URL("https://invictus-telemetry-qa.apps.pcfepg3mi.gm.com/telemetry")

        } else if (window.location.host.includes('perf')) {
            return new URL("https://invictus-telemetry-perf.cp-epgstg1i.gm.com/telemetry")

        } else {
            return new URL("https://invictus-telemetry-dev.cp-epg3i.gm.com/telemetry")
        }
    } else {
        return new URL("http://localhost:8080")
    }

}

const getEnvName = () => {

    if (window.location.host.includes('pdg')) {
        if (window.location.host.includes('preprod')) {
            return "PDG PreProd"

        } else if (window.location.host.includes('prod')) {
            return "PDG Production"
        }
    }

    if (window.location.host.includes('preprod')) {
        return "Preprod"

    } else if (window.location.host.includes('prod') ||
        window.location.host.includes('3dviz-tlm-ui.musea2.azure.ext.gm.com')) {
        return "Production"

    } else if (window.location.host.includes('test')) {
        return "Test"

    } else if (window.location.host.includes('qa')) {
        return "QA"

    } else if (window.location.host.includes('perf')) {
        return "Perf"

    } else {
        return "Development"
    }
}

interface MachineGroups {
  [index: string]: iMachineProps[]
}

const getMachineDcGroups = (machineList: iMachineProps[]) => {
    return machineList.reduce<MachineGroups>((prev, curr)=> {
      const dc = curr.datacenter;
      if (!prev[dc]) {
        prev[dc] = [];
      }

      prev[dc].push(curr)

      return prev;
    }, {})

}

export {getApiPath, getEnvName, getMachineDcGroups}